import { createFileRoute, useRouter } from '@tanstack/react-router'

import { FEATURE_MODULAR_DASHBOARD } from '@/core/constants/features'
import useFeatures from '@/core/utils/features/useFeatures'
import { TopicSection } from '@/topic/components/TopicSection/TopicSection'

export const Route = createFileRoute(
  '/_learning/home/_overview/view/$channel/$topic',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { topic: topicSlug } = Route.useParams()
  const router = useRouter()
  const hasModularDashboard = useFeatures(FEATURE_MODULAR_DASHBOARD)
  const returnUrl = router.buildLocation({ to: '/home' }).href

  return (
    <TopicSection
      lectureContext="channel"
      modularDashboardVersion={hasModularDashboard}
      returnUrl={returnUrl}
      topicSlug={topicSlug}
    />
  )
}
